import { api } from "./client";
import { unwrapApiData } from "./unwrap";
import type { ApiErrorBody } from "./types";

export type ZkOrgHealth = "none" | "online" | "degraded" | "offline";

export interface IntegrationSyncStatus {
  shopify: {
    configured: boolean;
    shopDomain: string | null;
    settingsUpdatedAt: string | null;
  };
  zkteco: {
    deviceCount: number;
    activeDeviceCount: number;
    health: ZkOrgHealth;
  };
  ops: {
    whatsappWebhookConfigured: boolean;
  };
}

export async function fetchIntegrationSyncStatus(): Promise<IntegrationSyncStatus> {
  const data = await api.get<
    { ok: true; data: IntegrationSyncStatus } | ApiErrorBody
  >("/v1/integrations/sync/status");
  return unwrapApiData(data);
}

export async function queueShopifyPullOrders(sinceIso?: string): Promise<{ queued: boolean; job: string }> {
  const data = await api.post<
    { ok: true; data: { queued: boolean; job: string } } | ApiErrorBody
  >("/v1/integrations/sync/shopify/pull-orders", sinceIso ? { sinceIso } : {});
  return unwrapApiData(data);
}

export async function queueBiometricReconcile(): Promise<{ queued: boolean; job: string }> {
  const data = await api.post<
    { ok: true; data: { queued: boolean; job: string } } | ApiErrorBody
  >("/v1/integrations/sync/biometric/reconcile", {});
  return unwrapApiData(data);
}

export async function sendOpsTestAlert(): Promise<{ sent: boolean }> {
  const data = await api.post<
    { ok: true; data: { sent: boolean } } | ApiErrorBody
  >("/v1/integrations/sync/ops/test-alert", {});
  return unwrapApiData(data);
}

export async function queueSilentAuditor(): Promise<{ queued: boolean; job: string }> {
  const data = await api.post<
    { ok: true; data: { queued: boolean; job: string } } | ApiErrorBody
  >("/v1/integrations/sync/auditor/run", {});
  return unwrapApiData(data);
}
